import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const LandingPageSubheader = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12699"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12699)">
          <rect
            x="-4"
            y="-3"
            width="124"
            height="115"
            rx="5.43652"
            fill="#FFEDBF"
          />
          <g clipPath="url(#clip0_1529_12699)">
            <g clipPath="url(#clip1_1529_12699)">
              <path
                d="M87.7195 35.2637V84.8576C87.7195 86.5017 87.0664 88.0785 85.9038 89.2411C84.7412 90.4037 83.1644 91.0568 81.5203 91.0568H22.6275C20.9833 91.0568 19.4065 90.4037 18.2439 89.2411C17.0814 88.0785 16.4282 86.5017 16.4282 84.8576V35.2637H87.7195Z"
                fill="#66E1FF"
              />
              <path
                d="M16.4282 35.2637V84.8576C16.4282 86.5017 17.0814 88.0785 18.2439 89.2411C19.4065 90.4037 20.9833 91.0568 22.6275 91.0568H25.7271L81.5203 35.2637H16.4282Z"
                fill="#C2F3FF"
              />
              <path
                d="M87.7195 35.2636H16.4282V25.9647C16.4282 24.3206 17.0814 22.7438 18.2439 21.5812C19.4065 20.4186 20.9833 19.7655 22.6275 19.7655H81.5203C83.1644 19.7655 84.7412 20.4186 85.9038 21.5812C87.0664 22.7438 87.7195 24.3206 87.7195 25.9647V35.2636Z"
                fill="white"
              />
              <path
                d="M81.5203 19.7655H22.6275C20.9833 19.7655 19.4065 20.4186 18.2439 21.5812C17.0814 22.7438 16.4282 24.3206 16.4282 25.9647V84.8575C16.4282 86.5017 17.0814 88.0785 18.2439 89.2411C19.4065 90.4036 20.9833 91.0568 22.6275 91.0568H81.5203C83.1644 91.0568 84.7412 90.4036 85.9038 89.2411C87.0664 88.0785 87.7195 86.5017 87.7195 84.8575V25.9647C87.7195 24.3206 87.0664 22.7438 85.9038 21.5812C84.7412 20.4186 83.1644 19.7655 81.5203 19.7655Z"
                stroke="#191919"
                strokeWidth="1.01935"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16.4282 35.2637H87.7195"
                stroke="#191919"
                strokeWidth="1.01935"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M27.2769 28.2894C27.0713 28.2894 26.8742 28.2078 26.7289 28.0625C26.5836 27.9171 26.502 27.72 26.502 27.5145C26.502 27.309 26.5836 27.1119 26.7289 26.9666C26.8742 26.8213 27.0713 26.7396 27.2769 26.7396"
                stroke="#191919"
                strokeWidth="1.01935"
              />
              <path
                d="M27.2769 28.2894C27.4824 28.2894 27.6795 28.2078 27.8248 28.0625C27.9701 27.9171 28.0518 27.72 28.0518 27.5145C28.0518 27.309 27.9701 27.1119 27.8248 26.9666C27.6795 26.8213 27.4824 26.7396 27.2769 26.7396"
                stroke="#191919"
                strokeWidth="1.01935"
              />
              <path
                d="M76.8708 41.363H27.2769C26.8658 41.363 26.4716 41.5263 26.181 41.817C25.8903 42.1076 25.7271 42.5018 25.7271 42.9128V49.1121C25.7271 49.5231 25.8903 49.9173 26.181 50.208C26.4716 50.4986 26.8658 50.6619 27.2769 50.6619H76.8708C77.2818 50.6619 77.676 50.4986 77.9667 50.208C78.2573 49.9173 78.4206 49.5231 78.4206 49.1121V42.9128C78.4206 42.5018 78.2573 42.1076 77.9667 41.817C77.676 41.5263 77.2818 41.363 76.8708 41.363Z"
                fill="#FFEF5E"
              />
              <path
                d="M27.2769 41.363C26.8658 41.363 26.4716 41.5263 26.181 41.817C25.8903 42.1076 25.7271 42.5018 25.7271 42.9128V49.1121C25.7271 49.5231 25.8903 49.9173 26.181 50.208C26.4716 50.4986 26.8658 50.6619 27.2769 50.6619H62.9225L72.2214 41.363H27.2769Z"
                fill="#FFF9BF"
              />
              <path
                d="M76.8708 41.363H27.2769C26.8658 41.363 26.4716 41.5263 26.181 41.817C25.8903 42.1076 25.7271 42.5018 25.7271 42.9128V49.1121C25.7271 49.5231 25.8903 49.9173 26.181 50.208C26.4716 50.4986 26.8658 50.6619 27.2769 50.6619H76.8708C77.2818 50.6619 77.676 50.4986 77.9667 50.208C78.2573 49.9173 78.4206 49.5231 78.4206 49.1121V42.9128C78.4206 42.5018 78.2573 42.1076 77.9667 41.817C77.676 41.5263 77.2818 41.363 76.8708 41.363Z"
                stroke="#191919"
                strokeWidth="1.01935"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <g clipPath="url(#clip2_1529_12699)">
                <path
                  d="M35.8304 76.6477H67.6376C68.346 76.6477 69.0254 76.9291 69.5263 77.4301C70.0272 77.931 70.3087 78.6104 70.3087 79.3188V104.765C70.3087 105.473 70.0272 106.152 69.5263 106.653C69.0254 107.154 68.346 107.436 67.6376 107.436H35.8304C35.122 107.436 34.4426 107.154 33.9417 106.653C33.4407 106.152 33.1593 105.473 33.1593 104.765V79.3188C33.1593 78.6104 33.4407 77.931 33.9417 77.4301C34.4426 76.9292 35.122 76.6477 35.8304 76.6477Z"
                  fill="#FFEF5E"
                  stroke="#191919"
                  strokeWidth="1.01935"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <mask
                  id="path-14-inside-1_1529_12699"
                  fill="white"
                >
                  <path d="M32.9919 78.0659L69.2324 104.417L32.9919 78.0659Z" />
                </mask>
                <path
                  d="M33.5914 77.2415C33.1361 76.9104 32.4986 77.0111 32.1675 77.4665C31.8364 77.9218 31.9372 78.5593 32.3925 78.8904L33.5914 77.2415ZM68.6329 105.241C69.0883 105.572 69.7258 105.471 70.0568 105.016C70.3879 104.561 70.2872 103.923 69.8319 103.592L68.6329 105.241ZM32.3925 78.8904L68.6329 105.241L69.8319 103.592L33.5914 77.2415L32.3925 78.8904Z"
                  fill="#191919"
                  mask="url(#path-14-inside-1_1529_12699)"
                />
              </g>
              <path
                d="M47.5242 58.8514H78.5204"
                stroke="#191919"
                strokeWidth="1.01935"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M47.5242 65.0505H72.1212"
                stroke="#191919"
                strokeWidth="1.01935"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M36.5757 28.2894C36.3702 28.2894 36.1731 28.2078 36.0277 28.0625C35.8824 27.9171 35.8008 27.72 35.8008 27.5145C35.8008 27.309 35.8824 27.1119 36.0277 26.9666C36.1731 26.8213 36.3702 26.7396 36.5757 26.7396"
                stroke="#191919"
                strokeWidth="1.01935"
              />
              <path
                d="M36.5757 28.2894C36.7812 28.2894 36.9783 28.2078 37.1236 28.0625C37.2689 27.9171 37.3506 27.72 37.3506 27.5145C37.3506 27.309 37.2689 27.1119 37.1236 26.9666C36.9783 26.8213 36.7812 26.7396 36.5757 26.7396"
                stroke="#191919"
                strokeWidth="1.01935"
              />
              <path
                d="M45.8745 28.2894C45.669 28.2894 45.4719 28.2078 45.3266 28.0625C45.1813 27.9171 45.0996 27.72 45.0996 27.5145C45.0996 27.309 45.1813 27.1119 45.3266 26.9666C45.4719 26.8213 45.669 26.7396 45.8745 26.7396"
                stroke="#191919"
                strokeWidth="1.01935"
              />
              <path
                d="M45.8745 28.2894C46.08 28.2894 46.2771 28.2078 46.4225 28.0625C46.5678 27.9171 46.6494 27.72 46.6494 27.5145C46.6494 27.309 46.5678 27.1119 46.4225 26.9666C46.2771 26.8213 46.08 26.7396 45.8745 26.7396"
                stroke="#191919"
                strokeWidth="1.01935"
              />
              <g clipPath="url(#clip3_1529_12699)">
                <path
                  d="M34.0654 76.8176L69.7425 102.981"
                  stroke="#191919"
                  strokeWidth="1.01935"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M34.7322 102.981L68.7391 76.8175"
                  stroke="#191919"
                  strokeWidth="1.01935"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
            <path
              d="M40.1813 55.7512C40.1813 55.3759 40.4855 55.0717 40.8608 55.0717H100.662C101.038 55.0717 101.342 55.3759 101.342 55.7512V70.0614C101.342 70.4367 101.038 70.741 100.662 70.741H40.8608C40.4855 70.741 40.1813 70.4367 40.1813 70.0614V55.7512Z"
              fill="white"
              stroke="#1E1E1E"
              strokeWidth="1.35913"
            />
            <path
              d="M43.9382 60.4418V59.6352C43.9382 59.4213 44.0232 59.2161 44.1745 59.0649C44.3258 58.9136 44.5309 58.8286 44.7448 58.8286H50.3911C50.6051 58.8286 50.8102 58.9136 50.9615 59.0649C51.1128 59.2161 51.1977 59.4213 51.1977 59.6352V60.4418"
              stroke="#1E1E1E"
              strokeWidth="1.35913"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M47.5676 58.8286V66.0881"
              stroke="#1E1E1E"
              strokeWidth="1.35913"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M45.9551 66.0881H49.1815"
              stroke="#1E1E1E"
              strokeWidth="1.35913"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M53.3936 66.4915H60.5634"
              stroke="#1E1E1E"
              strokeWidth="1.35913"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1529_12699">
            <rect
              width="125.719"
              height="76.7906"
              fill="white"
              transform="translate(-10.7859 17.0161)"
            />
          </clipPath>
          <clipPath id="clip1_1529_12699">
            <rect
              width="76.7906"
              height="74.7519"
              fill="white"
              transform="translate(13.6785 17.016)"
            />
          </clipPath>
          <clipPath id="clip2_1529_12699">
            <rect
              width="39.4146"
              height="14.2708"
              fill="white"
              transform="translate(32.0266 76.1381)"
            />
          </clipPath>
          <clipPath id="clip3_1529_12699">
            <rect
              width="35.6771"
              height="14.2708"
              fill="white"
              transform="translate(34.0654 76.8176)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
